import { lazy } from "react";
import Loadable from "components/Loadable";

const Success = Loadable(lazy(() => import("pages/Payment/Success")));
const Failure = Loadable(lazy(() => import("pages/Payment/Failure")));

const PublicPaymentRoutes = {
    path: "/",
    children: [
        {
            path: "success",
            element: <Success />,
        },
        {
            path: "failure",
            element: <Failure />,
        },
    ],
};

export default PublicPaymentRoutes;